<template>
  <!-- 职级变更记录 -->
  <div class="wrapper">
    <div class="content">
      <div class="search-box min">
        <div class="input-item">
          <span class="label">业务员</span>
          <Select clearable v-model="searchParams.userId" style="width:256px;" filterable :transfer="true">
            <Option v-for="(item, i) in salesmanList" :key="i" :value="item.id" :label="item.name">
              <span class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></span>
              {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
            </Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">机构/团队</span>
          <selectTree type="2" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">生效日期</span>
          <DatePicker type="daterange" split-panels separator="至" :transfer="true" placement="bottom" format="yyyy-MM-dd"
            placeholder="选择日期" :value="searchParams.date" @on-change="searchParams.date = $event"></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">操作日期</span>
          <DatePicker type="daterange" split-panels separator="至" :transfer="true" placement="bottom" format="yyyy-MM-dd"
            placeholder="选择日期" :value="searchParams.date1" @on-change="searchParams.date1 = $event"></DatePicker>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <!-- <Button v-if="$units.pointAction('org_3_5')" type="warning" @click="$refs.promotionModal.open()">新增</Button> -->
        </div>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="attachments">
            <a v-if="row.attachments" :href="row.attachments[0].path" target="_blank">{{ row.attachments[0].fileName
            }}</a>
          </template>
        </Table>
        <div class="pageBox">
          <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
            style="text-align: center" />
        </div>
      </div>
    </div>
    <!-- 晋升 -->
    <promotionModal ref="promotionModal" @reload="searchAjax()"></promotionModal>
  </div>
</template>

<script>
import filters from "@/api/filter";
import { pageTool } from "@/api/mixins";
import promotionModal from "./promotionModal";
import selectTree from "@/components/system/selectTree3";
export default {
  mixins: [pageTool],
  components: {
    selectTree,
    promotionModal,
  },
  props: {
    isShow: null
  },
  data() {
    return {
      //表单搜索字段
      columns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "工号",
          key: "staffNo",
          align: "center",
          minWidth: 120,
        },
        {
          title: "业务员名称",
          key: "userName",
          align: "center",
          minWidth: 120,
        },
        {
          title: "变更前组织",
          key: "oldOrganizationName",
          align: "center",
          minWidth: 160,
          render(h, params) {
            const text = `${params.row.oldOrganizationName || '-'}/${params.row.oldGroupName || '-'}`;
            return <span>{text}</span>;
          },
        },
        {
          title: "变更后组织",
          key: "newOrganizationName",
          align: "center",
          minWidth: 160,
          render(h, params) {
            const text = `${params.row.newOrganizationName || '-'}/${params.row.newGroupName || '-'}`;
            return <span>{text}</span>;
          },
        },
        {
          title: "原职级/新职级",
          key: "oldRankName",
          align: "center",
          minWidth: 160,
          render(h, params) {
            const text = `${params.row.oldRankName || '-'}/${params.row.newRankName || '-'}`;
            return <span>{text}</span>;
          },
        },
        {
          title: "生效日期",
          key: "effectiveDate",
          align: "center",
          width: 140,
          render(h, params) {
            const value = filters.filterTime(params.row.effectiveDate, 'YYYY-MM-DD HH:mm')
            return <span>{value}</span>
          },
        },
        {
          title: "备注",
          key: "remark",
          align: "center",
          minWidth: 200,
          render(h, params) {
            let text = params.row.remark;
            return h(
              'Tooltip',
              {
                class: 'flex-center',
                props: { placement: 'bottom-start', transfer: true }
              },
              [
                h(
                  'span',
                  {
                    class: 'txt-ellipsis2'
                  },
                  text
                ),
                h('span', { slot: 'content' }, text)
              ]
            );
          }
        },
        {
          title: "附件",
          slot: "attachments",
          align: "center",
          minWidth: 140,
        },
        {
          title: "操作日期",
          key: "createTime",
          align: "center",
          minWidth: 140,
          render(h, params) {
            const value = filters.filterTime(params.row.createTime, 'YYYY-MM-DD HH:mm')
            return <span>{value}</span>
          },
        },
        {
          title: "操作人",
          key: "operateName",
          align: "center",
          minWidth: 120,
        },
      ],
      groupList: [],
      salesmanList: []
    };
  },
  watch: {
    isShow: {
      handler(newval, oldval) {
        if (newval) {
          this.initListAjax("/buz/userRankChangeRecord/read/list");
        }
      },
      immediate: true,
    }
  },
  computed: {
  },
  activated(){
    this.getOrganizationUser()
    this.getList()
  },
  mounted() {
    
  },
  methods: {
    listCallback(res) {
      this.tableData = res.data.map(item => {
        if (item.attachments) {
          item.attachments = JSON.parse(item.attachments)
        }
        return item
      })
    },
    setReqParams(params) {
      params.apiPermissionCode = 'org_3_0';
    },
    // 通过机构获取业务员
    getOrganizationUser() {
      this.$http({
        url: `/buz/userBase/getByOrgIds`,
        type: "POST",
        data: {
        }
      }).then((res) => {
        this.salesmanList = res.data;
      })
    },
    // 转化参数
    setListParams(params) {
      params.status = 1;
      if (this.searchParams.date && this.searchParams.date.length > 0) {
        params.effectiveDateStart = this.searchParams.date[0]
        params.effectiveDateEnd = this.searchParams.date[1]
      }
      if (this.searchParams.date1 && this.searchParams.date1.length > 0) {
        params.createTimeStart = this.searchParams.date1[0]
        params.createTimeEnd = this.searchParams.date1[1]
      }
      delete params.date
      delete params.date1
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {//机构
        this.searchParams.organId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {//团队
        this.searchParams.organId = "";
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.organId = "";
        this.searchParams.groupId = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);

  &.red {
    background: #e3461f;
  }
}

.wrapper .content {
  .search-box {
    .label {
      // min-width: 80px;
      font-size: 13px;
    }

    /deep/ .ivu-input {
      font-size: 13px;
    }

    /deep/.ivu-select-selected-value {
      font-size: 13px;
    }

    .btn-item {
      .ivu-btn {
        font-size: 13px;
      }
    }
  }
}
</style>
